module.exports = __webpack_public_path__ + "static/media/logoMaxLife.fab642ee.png";